export default __webpack_public_path__ + "static/media/dining.8ae2bc75.jpg";